import { Component, input, Input, OnInit } from "@angular/core";
import { AuthService } from "@core/services/auth/auth.service";

import { IframeRatio } from "@shared/schemas/enums/iframe-ratio";
import { PostMessageService } from "@shared/services/post-message.service";
@Component({
	selector: "app-iframe-container",
	templateUrl: "./iframe-container.component.html",
	styleUrls: ["./iframe-container.component.scss"],
	standalone: false
})
export class IframeContainerComponent implements OnInit {
	@Input() title = "";
	@Input() urlToRender = "";
	@Input() aspectRatio = IframeRatio.SIXTEEN_TO_NINE;
	@Input() showSkeleton = true;
	@Input() refreshJsfAfterExpiredToken = true;
	@Input() skeletonType: "dashboard" | "generic" = "generic";

	customIframe = input<boolean>(false);

	isLoading = true;

	constructor(
		private authService: AuthService,
		private postMessageService: PostMessageService
	) {}

	ngOnInit(): void {
		this.verifyTokenExpiraton();
	}

	onLoad(element: HTMLIFrameElement): void {
		if (this.isReadyToLoad(element)) {
			this.isLoading = false;
			this.postMessageService.setIframe(element);
		}
	}

	private isReadyToLoad(element: HTMLIFrameElement): boolean {
		return this.urlToRender !== "" && this.urlToRender === element.src;
	}

	private verifyTokenExpiraton(): void {
		if (
			this.refreshJsfAfterExpiredToken &&
			this.authService.getUserLogin() &&
			this.authService.getExpirationUnix() > 0 &&
			Date.now() >= this.authService.getExpirationUnix()
		) {
			this.authService.refreshToken().subscribe({
				next: () => location.reload(),
				error: () => this.authService.logout().subscribe()
			});
		}
	}
}
